//
//
//
//
//
//
//
//
//
//
//
import List from './List.vue';
import Edit from './Edit.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    List: List,
    Edit: Edit
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      isShowList: true,
      isShowEdit: false
    };
  },
  watch: {
    $OutsourcedState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态 MaintainDeliveryNote2OrderState==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.isShowList = true;
          this.isShowEdit = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.isShowList = false;
          this.isShowEdit = true;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowList = false;
          this.isShowEdit = true;
        } else if (nawValue === 'editOrder') {}
      },
      immediate: true
    }
  },
  methods: {
    onClickDELIVERY_NO: function onClickDELIVERY_NO(row) {
      this.$refs.Edit.setHeaderForDELIVERY_NO(row);
    }
  },
  computed: {}
};